import {
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Pagination,
  Select,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { EmptyState } from "components/EmptyState";

import { ReactComponent as AddCircle } from "assets/Svgs/AddCircle.svg";

import i18n from "i18n/i18n";
import { Link, useNavigate } from "react-router-dom";
import { useBoundStore } from "store/store";
import { useEffect, useState } from "react";
import ManuallReportListing from "./ManualReportsListing";
import BadgeTabs from "components/BadgeTabs";
import { chunk } from "lodash";

function ManualReports() {
  const lang: any = useBoundStore((state) => state.lang);
  const legalEntityNodeId = useBoundStore((state) => state.legalEntityNodeId);
  const getAllReportConfigurations = useBoundStore(
    (state) => state.getAllReportConfigurations
  );
  useEffect(() => {
    getAllReportConfigurations(legalEntityNodeId);
  }, []);

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const getReportConfigurations: any = useBoundStore(
    (state) => state.getReportConfigurations
  );
  let reports = getReportConfigurations.result?.length
    ? getReportConfigurations.result[0].data.length > 0 &&
      getReportConfigurations.result[0].data[0].legalentity.hasreportconfiguration.filter(
        (report: any) => {
          return report.reportconfiguration.triggertype === "manual";
        }
      )
    : [];

 
  const [page, setPage] = useState(0);

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
   
  };

  let paginationchunks = chunk(reports, rowsPerPage);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage - 1);
  };

  const getAllReports = useBoundStore((state) => state.getAllReports);

  const getAllReportsFnc = () => {
    setTimeout(() => {
      getAllReportConfigurations(legalEntityNodeId);
    }, 1000);
  };

  return (
    <Card className="initialCard" sx={{ padding: 0 }}>
      {reports.length ? (
        <>
          <div
            className="reportsHeader"
            style={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <div className="title" style={{ marginBottom: 0 }}>
              {i18n(lang)?.manualReportsTitle} ({reports.length})
            </div>
            <Link
              to={"/new-report"}
              state={{ activeId: 2, reportType: "manual" }}
            >
              <Button
               
                startIcon={<AddIcon />}
                variant="contained"
                className="lp125"
                sx={{
                  backgroundColor: "var(--primary-color)",
                  letterSpacing: "1.25px",
                  marginLeft: "20px",
                }}
              >
                {i18n(lang)?.new}
              </Button>
            </Link>
          </div>

          <div className="reportsListingWrapper">
            {reports.length > 0
              ? reports
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: any) => {
                    return (
                      <ManuallReportListing
                        report={row}
                        getAllReports={getAllReportsFnc}
                      />
                    );
                  })
              : ""}
          </div>

          {paginationchunks.length > 0 ? (
            <div className="DashboardTablePagination reportsHeader">
              <div>
                <Pagination
                  count={paginationchunks.length}
                  shape="rounded"
                  onChange={handleChangePage}
                  hideNextButton={page === paginationchunks.length - 1}
                  hidePrevButton={page === 0}
                />
              </div>
              <div>
                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                  <Select
                    id="demo-simple-select-standard"
                    value={rowsPerPage}
                    onChange={handleChangeRowsPerPage}
                   
                    className="perPageSelect"
                  >
                    <MenuItem value={5}>
                      {5}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 2}>
                      {5 * 2}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 5}>
                      {5 * 5}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                    <MenuItem value={5 * 10}>
                      {5 * 10}
                      {i18n(lang)?.rows_per_page}
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          <div
            className="reportsHeader"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="title">{i18n(lang)?.manualReportsTitle} (0)</div>
            <div className="checkbox">
              
            </div>
          </div>

          <EmptyState
            title={i18n(lang)?.manualReportsEmptyStateTitle}
            description={i18n(lang)?.manualReportsEmptystateDescription}
            icon={<AddCircle />}
            hasButton
            button={
              <div style={{ marginTop: "20px" }}>
                <Link
                  to={"/new-report"}
                  state={{ activeId: 2, reportType: "manual" }}
                >
                  <Button
                   
                    startIcon={<AddIcon />}
                    variant="contained"
                    className="lp125"
                    sx={{
                      backgroundColor: "var(--primary-color)",
                      letterSpacing: "1.25px",
                    }}
                  >
                    {i18n(lang)?.manualReportsEmptyStateBtn}
                  </Button>
                </Link>
              </div>
            }
          />
        </>
      )}
    </Card>
  );
}

export default ManualReports;
